import React from "react";
import "./heroSection.css";
import heroImg from "./hero-job-listing.png";

const HeroSection = () => (
  <section className="about-hero">
    <h1 className="about-hero__title">
      PLATAFORMA DE RECLUTAMIENTO Y SELECCIÓN GASTRONÓMICA
    </h1>
    <div className="about-hero__grid">
      <div className="about-hero__content">
        <p>
          GourmetJobs es una plataforma especializada en reclutamiento
          gastronómico, diseñada para conectar de forma rápida, precisa y
          eficiente a empresas del rubro con el mejor talento disponible.
        </p>
        <p>
          Nos especializamos 100% en el sector gastronómico, lo que nos permite
          ofrecer una solución hecha a medida: bases de datos exclusivas,
          herramientas inteligentes y procesos optimizados que aseguran el match
          perfecto entre trabajadores y empresas.
        </p>
        <p>
          A través de nuestra tecnología, transformamos el proceso de selección
          en una experiencia ágil, eficaz y enfocada en resultados. Ayudamos a
          las empresas a contratar mejor y más rápido, y a los trabajadores del
          rubro a encontrar oportunidades alineadas con sus experiencias,
          habilidades y proyección laboral. GourmetJobs no es una bolsa de
          empleo. Es la evolución del reclutamiento gastronómico.
        </p>
      </div>

      <div className="about-hero__image-wrapper">
        <img src={heroImg} alt="GourmetJobs Platform" />
      </div>
    </div>
  </section>
);

export default HeroSection;
